__turbopack_context__.v({
  "active": "style-module-scss-module__Nnpawq__active",
  "filterButton": "style-module-scss-module__Nnpawq__filterButton",
  "filterClearIcon": "style-module-scss-module__Nnpawq__filterClearIcon",
  "filtersGroup": "style-module-scss-module__Nnpawq__filtersGroup",
  "groupTitle": "style-module-scss-module__Nnpawq__groupTitle",
  "wrapper": "style-module-scss-module__Nnpawq__wrapper",
});
